import { Box } from '@mui/material';
import { CreditReportGridData } from './CreditReportGridData';
import { ICreditReport } from './interfaces/interfaces';

interface IAutoSummary {
  loan: ICreditReport['autoSummaryProfile']['autoSummaryProfileDetails'];
}

export const AutoSummary = ({ loan }: IAutoSummary) => (
  <Box marginBottom={2}>
    <CreditReportGridData tableName="Auto Summary" data={loan} />
  </Box>
);
